import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "D:\\\u9879\u76EE\\blueSkyReportForm\\node_modules\\core-js\\modules\\es.array.iterator.js";
import "D:\\\u9879\u76EE\\blueSkyReportForm\\node_modules\\core-js\\modules\\es.promise.js";
import "D:\\\u9879\u76EE\\blueSkyReportForm\\node_modules\\core-js\\modules\\es.object.assign.js";
import "D:\\\u9879\u76EE\\blueSkyReportForm\\node_modules\\core-js\\modules\\es.promise.finally.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import 'flex.css';
import App from './App.vue';
import store from './store';
import router from './router';
import 'default-passive-events';
import { ImagePreview } from 'vant';
import { globalRegister } from './global';
import { userLogin } from '@/service/user';
import localCache from '@/utils/localCache';
import { DEVELOPMENT } from '@/config/common';
import '@/assets/css/custom.less';
var app = createApp(App);
app.use(store);
app.use(router);
app.use(globalRegister);
app.mount('#app');
app.use(ImagePreview);
if (localCache.getItem('curSiderbarIndex')) {
  var curSiderbarIndex = Number(localCache.getItem('curSiderbarIndex'));
  store.commit('production/updateSiderbarIndex', curSiderbarIndex);
}
if (localCache.getItem('siderbar')) {
  var siderbar = JSON.parse(localCache.getItem('siderbar'));
  store.commit('production/updateSiderbar', siderbar);
}
if (localCache.getItem('curSiderbarId')) {
  var curSiderbarId = localCache.getItem('curSiderbarId');
  store.commit('production/updateSiderbarId', curSiderbarId);
}
if (localCache.getItem('vibrationCurSiderbarIndex')) {
  var _curSiderbarIndex = Number(localCache.getItem('vibrationCurSiderbarIndex'));
  store.commit('vibrationEquipment/updateSiderbarIndex', _curSiderbarIndex);
}
if (localCache.getItem('vibrationSiderbar')) {
  var _siderbar = JSON.parse(localCache.getItem('vibrationSiderbar'));
  store.commit('vibrationEquipment/updateSiderbar', _siderbar);
}
if (localCache.getItem('vibrationCurSiderbarId')) {
  var _curSiderbarId = localCache.getItem('vibrationCurSiderbarId');
  store.commit('vibrationEquipment/updateSiderbarId', _curSiderbarId);
}
if (localCache.getItem('useList')) {
  var useList = JSON.parse(localCache.getItem('useList'));
  store.commit('production/updateUseList', useList);
}
if (localCache.getItem('drawList')) {
  var drawList = JSON.parse(localCache.getItem('drawList'));
  store.commit('production/updateDrawList', drawList);
}
//为了是element-plus的date-picker的周第一天为周六  ----start weekStart改为6
import dayjs from 'dayjs';
import zhCn from 'dayjs/locale/zh-cn';
zhCn.weekStart = 7; // 蓝天周六到周五是一周，weekStart改为6  标准版周日到周六是一周，weekStart改为7
dayjs.locale(zhCn);
// 为了是 element-plus 的 date-picker  的周第一天为周六  ----end
function userInit() {
  return _userInit.apply(this, arguments);
}
function _userInit() {
  _userInit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    var token, data, userToken, userFactoryId;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          token = localCache.getItem('token');
          if (token) {
            _context2.next = 9;
            break;
          }
          _context2.next = 4;
          return userLogin();
        case 4:
          data = _context2.sent;
          userToken = data.user_token;
          userFactoryId = data.factory;
          if (userToken) {
            localCache.setItem('token', userToken);
          }
          if (userFactoryId) {
            localCache.setItem('factoryId', userFactoryId);
          }
        case 9:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _userInit.apply(this, arguments);
}
router.beforeEach( /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(to) {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!_.eq(process.env.NODE_ENV, DEVELOPMENT)) {
            _context.next = 5;
            break;
          }
          _context.next = 3;
          return userInit();
        case 3:
          _context.next = 7;
          break;
        case 5:
          if (to.query.token) {
            localCache.setItem('token', to.query.token);
          }
          if (to.query.factoryId) {
            localCache.setItem('factoryId', to.query.factoryId);
          }
        case 7:
          return _context.abrupt("return", true);
        case 8:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x) {
    return _ref.apply(this, arguments);
  };
}());